// Custom Block Library — React hook: the three access gates + remote refresh.

import { useEffect, useReducer } from 'react';
import { blockLibraryGate, type BlockLibraryGates } from './blockLibraryFlags';
import { ensureBlockLibraryConfig, getBlockLibraryFlagsState, subscribeBlockLibraryConfig } from './blockLibraryRemoteKill';

export function useBlockLibraryGate(): BlockLibraryGates {
  const [, force] = useReducer((x: number) => x + 1, 0);
  useEffect(() => {
    ensureBlockLibraryConfig();
    return subscribeBlockLibraryConfig(force);
  }, []);
  return blockLibraryGate({ state: getBlockLibraryFlagsState() });
}
